var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg089Telegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.799,
    height: 24,
    viewBox: "0 0 28.799 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_089-telegram",
    "data-name": "089-telegram",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67392",
    "data-name": "Group 67392",
    transform: "translate(-0.004 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67391",
    "data-name": "Group 67391",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80457",
    "data-name": "Path 80457",
    d: "M11.3,58.476l-.476,6.7a1.666,1.666,0,0,0,1.331-.644l3.2-3.054,6.622,4.849c1.214.677,2.07.32,2.4-1.117l4.346-20.366h0c.385-1.8-.649-2.5-1.832-2.057L1.333,52.567c-1.744.677-1.717,1.649-.3,2.089l6.532,2.032L22.74,47.194c.714-.473,1.363-.211.829.262Z",
    transform: "translate(0.004 -42.658)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg089Telegram);
export default __webpack_public_path__ + "static/media/089-telegram.384f74aa26075629334fd5e7570d75bb.svg";
export { ForwardRef as ReactComponent };